module.exports = __webpack_public_path__ + "01b7a8d2aaebff62815ea3b72e36bcfd.png";